export function CompetenceGraphLegend() {
  return (
    <div className={"flex items-end"}>
      <div
        className={
          "bg-white w-full rounded-2 grid grid-cols-2 text-black p-3 gap-sm"
        }
      >
        <div className="flex gap-x-sm">
          <div className="h-5 w-9 bg-dark-green rounded-2" />
          <span>Less than 5</span>
        </div>
        <div className="flex gap-x-sm">
          <div className="h-5 w-9 bg-green-100 border border-black rounded-2" />
          <span>5 or more</span>
        </div>
        <div className="flex gap-x-sm col-span-full">
          <div className="h-5 w-9 bg-black border border-black rounded-2">
            <div className="bg-dotted-pattern w-full h-full"></div>
          </div>
          <span>Goal based on on your motivation scan</span>
        </div>
      </div>
    </div>
  );
}
